import styled from '@emotion/styled'

export const ProfileLabel = styled.span`
  ${({ theme: { typography } }) => typography.body3}
  width: fit-content;
  padding: 7px;
  display: inline-block;

  border-radius: 15px;
  background-color: ${({ theme: { colors } }) => colors.defaultText};
  color: ${({ theme: { colors } }) => colors.ghostText};
  font-family: GmarketSansMedium;

  font-weight: 500;
  letter-spacing: 0.4px;

  @media ${({ theme: { device } }) => device.mobile} {
    padding: 5px;
  }
`
